module.exports = __webpack_public_path__ + "media/4_1.cac48825.wav";